module.exports = "https://p.cds.unp.clasificados.pe/logo-clasificados.png";